import * as React from "react";
import { forwardRef } from "react";
const SvgStatusSuccessColor = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: "1rem", height: "1rem", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 0a8 8 0 108 8 8.024 8.024 0 00-8-8zM6.7 12L3 8.6l1.4-1.3 2.4 2.2L11.6 5 13 6.3z", fill: "var(--iui-color-icon-positive, hsl(118 74% 35%))" }));
const ForwardRef = forwardRef(SvgStatusSuccessColor);
export { ForwardRef as ReactComponent };
